import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import UserGuide from './UserGuide';

const HelpPage = () => {
  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        <div className="bg-card rounded-xl border border-border shadow-sm overflow-hidden" style={{ height: 'calc(100vh - 140px)' }}>
          <UserGuide />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default HelpPage;
